import { config } from '../index';

let xCoord;
let height;
let timeline1;
let interval;
let graphics;

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'LoadScene',
    });
  }

  preload() {
    this.load.image('loadCircle', 'assets/StartSceneAssets/loadAnims/loadCircle.png');
    this.load.image('rocket', 'assets/StartSceneAssets/loadAnims/rocketN.png');
    this.load.image('flame', 'assets/StartSceneAssets/loadAnims/flame.png');
    this.load.image('speedLine', 'assets/StartSceneAssets/loadAnims/speedLines.png');
  }

  create() {
    this.camera = this.cameras.main;

    this.loadingAnimationCreate();
    this.loadingAnimationP1();

    this.camera.setMask(this.circleMask);

    this.gameSceneAssetsLoad();

    this.load.start();

    this.load.on(
      'progress',
      value => {
        if (value < 1 && timeline1 && timeline1.isPaused()) {
          timeline1.play();
        }
      },
      this,
    );

    this.load.on(
      'complete',
      function () {
        this.loadingAnimationP2();
      },
      this,
    );
  }

  loadingAnimationCreate() {
    graphics = this.add.graphics();

    const color = 0x00ffff;
    const alpha = 1;

    graphics.fillStyle(color, alpha);

    this.loadCircle = this.add.sprite(config.width / 2, config.height / 2, 'loadCircle');

    this.circle = graphics
      .fillCircle(
        config.width / 2,
        config.height / 2,
        this.loadCircle.width / 2,
        0x00ffff,
      )
      .setVisible(false);

    this.mask = this.circle.createGeometryMask();

    this.rocket = this.add.sprite(0, 0 + 15, 'rocket').setDepth(2);
    this.flame = this.add.sprite(0, 0 + 77, 'flame').setDepth(2);

    this.container = this.add.container(config.width / 2, config.height / 2).setDepth(2);
    this.container.add(this.rocket);
    this.container.add(this.flame);

    this.rocket.setMask(this.mask);
    this.flame.setMask(this.mask);
  }

  loadingAnimationP1() {
    // Phaser 3.60+ removed `this.tweens.createTimeline()`. Use `tweens.chain()` instead.
    timeline1 = this.tweens.chain({
      targets: this.container,
      loop: -1,
      paused: true,
      tweens: [
        {
          x: this.container.x + 5,
          duration: 300,
          yoyo: true,
          ease: 'sine.easeInOut',
        },
        {
          y: this.container.y + 5,
          duration: 300,
          yoyo: true,
          ease: 'sine.easeInOut',
        },
        {
          x: this.container.x + 5,
          y: this.container.y + 5,
          duration: 300,
          yoyo: true,
          ease: 'sine.easeInOut',
        },
      ],
    });

    this.tweens.add({
      targets: this.flame,
      scaleX: 0.8,
      yoyo: true,
      loop: -1,
      duration: 300,
      ease: 'Bounce.easeInOut',
      loopDelay: 50,
    });

    interval = setInterval(() => {
      this.generateRandom(
        config.width / 2 + this.loadCircle.width / 2 - 20,
        config.width / 2 - this.loadCircle.width / 2 + 20,
      );
      this.line = this.add
        .sprite(xCoord, config.height / 2 - this.loadCircle.height / 2, 'speedLine')
        .setDepth(1)
        .setScale(1, height);
      this.line.setMask(this.circleMask);

      this.tweens.add({
        targets: this.line,
        y: 800,
        duration: 300,
        ease: 'Linear',
      });
    }, 200);
  }

  loadingAnimationP2() {
    this.tweens.add({
      targets: this.container,
      y: this.container.y + 100,
      duration: 400,
      ease: 'Cubic.easeOut',
      onComplete: () => {
        clearInterval(interval);
        if (this.line) this.line.setVisible(false);
        this.tweens.add({
          targets: this.container,
          y: -100,
          duration: 300,
          onComplete: () => {
            this.rocket.setVisible(false);
            this.flame.setVisible(false);
          },
        });
      },
    });

    this.tweens.add({
      onStart: () => {
        this.circle = graphics
          .fillCircle(
            config.width / 2,
            config.height / 2,
            (this.loadCircle.width / 2) * 1.5,
          )
          .setVisible(false);
      },
      targets: [this.loadCircle],
      scale: 1.5,
      duration: 300,
      ease: 'Power2',
      onComplete: () => {
        this.tweens.add({
          delay: 300,
          targets: [this.loadCircle],
          scale: 0,
          duration: 100,
          ease: 'Cubic.easeIn',
          onComplete: () => {
            this.scene.stop('LoadScene');
            this.scene.start('StartScene');
          },
        });
      },
    });
  }

  generateRandom(max, min) {
    height = Math.random() * (0.8 - 0.3) + 0.3;
    xCoord = Math.floor(Math.random() * (max - min + 1) + min);
    return (xCoord, height);
  }

  gameSceneAssetsLoad() {
    // StartScene assets
    this.load.image('bg', 'assets/StartSceneAssets/bg.png');
    this.load.multiatlas(
      'vinnieAnim',
      'assets/StartSceneAssets/Animations/vinnieCharAnimNew.json',
      'assets/StartSceneAssets/Animations/',
    );
    this.load.image('play', 'assets/StartSceneAssets/play.png');
    this.load.image('playBlack', 'assets/StartSceneAssets/playBlack.png');
    this.load.image('bulb', 'assets/StartSceneAssets/bulb.png');
    this.load.image('light', 'assets/StartSceneAssets/light.png');

    // GameScene assets
    this.load.image('gameBG', 'assets/GameSceneAssets/bg.png');
    this.load.image('section1New', 'assets/GameSceneAssets/section1New.png');
    this.load.image('switchBoard', 'assets/GameSceneAssets/switchBoard.png');
    this.load.image('switch', 'assets/GameSceneAssets/switch.png');
    this.load.image('wrong', 'assets/GameSceneAssets/wrong.png');
    this.load.image('fractionBox', 'assets/GameSceneAssets/fractionBox.png');
    this.load.image('line', 'assets/GameSceneAssets/line.png');
    this.load.image('yellowBorder', 'assets/GameSceneAssets/yellowBorder.png');
    this.load.image('hand', 'assets/GameSceneAssets/hand.png');
    this.load.image('overlay', 'assets/GameSceneAssets/overlay.png');
    this.load.image('yellowGlow', 'assets/GameSceneAssets/yellowBulb.png');
    this.load.image('greenGlow', 'assets/GameSceneAssets/greenGlow.png');
    this.load.image('redGlow', 'assets/GameSceneAssets/redGlow.png');
    this.load.image('redBulb', 'assets/GameSceneAssets/redBulb.png');
    this.load.image('confirm', 'assets/GameSceneAssets/confirm.png');
    this.load.image('confirmBlack', 'assets/GameSceneAssets/confirmBlack.png');
    this.load.multiatlas(
      'switchAnim',
      'assets/GameSceneAssets/switchAnim.json',
      'assets/GameSceneAssets',
    );
    this.load.multiatlas(
      'confetti',
      'assets/GameSceneAssets/confettiAnim.json',
      'assets/GameSceneAssets',
    );

    for (let i = 1; i <= 6; i++) {
      this.load.image('section' + i, 'assets/GameSceneAssets/section' + i + '.png');
      this.load.image('glow' + i, 'assets/GameSceneAssets/glow' + i + '.png');
      this.load.image('litUp' + i, 'assets/GameSceneAssets/litUp' + i + '.png');
    }

    for (let i = 1; i <= 13; i++) {
      this.load.image('s' + i, 'assets/GameSceneAssets/s' + i + '.png');
    }

    for (let i = 1; i <= 40; i++) {
      this.load.image('q' + i, 'assets/GameSceneAssets/q' + i + '.png');
    }

    // HintScene assets
    this.load.atlas(
      'hintFinalAnim',
      'assets/HintSceneAssets/hintFinalAnim.png',
      'assets/HintSceneAssets/hintFinalAnim.json',
    );
    this.load.image('hintClose', 'assets/HintSceneAssets/closeHint.png');
    this.load.image('hint1', 'assets/HintSceneAssets/hint1.png');
    this.load.image('hint2', 'assets/HintSceneAssets/hint2.png');

    // EndScene assets
    this.load.plugin(
      'rexkawaseblurpipelineplugin',
      'assets/EndSceneAssets/rexkawaseblurpipelineplugin.min.js',
      true,
    );
    this.load.multiatlas(
      'spotlight',
      'assets/EndSceneAssets/spotlight/spotlightAnimNew.json',
      'assets/EndSceneAssets/spotlight',
    );
  }

  update() {}
}
